export type AuthenticationState = {
    readonly spoc: SpocState;
};

export type SpocState = {
    readonly id: string; // e.g. "SITE1803"
    readonly name: string; // e.g. "Your School Library"
    readonly distributionTerritory: string; // e.g. "AU_LIB"
    readonly currency: string; // e.g. "AUD"
    readonly taxRate: number; // e.g. 0.1
    readonly taxName: string; // e.g. "GST"
    readonly taxCountry: string; // e.g. "AU"
    readonly selectable: boolean;
    readonly ebooksStockAmount: number; // e.g. 21873
    readonly eaudiobooksStockAmount: number; // e.g. 10000
    readonly epressStockAmount: number; // e.g. 10000
    readonly stockAmount: number; // e.g. 0
    readonly contentOrdersAllowed: boolean;
    readonly customCopyFormulaExists: boolean;
    readonly partnerId?: string; // e.g. "PARTNER1762", only present for sites
    readonly partnerName: string; // e.g. "Bolinda Test Partner", only present for sites
    readonly sites: ReadonlyArray<SpocState>; // only present for partners
    readonly shopLanguages: ReadonlyArray<ShopLanguageDetails>;
};

export type ShopLanguageDetails = {
    readonly shopLanguageId: string;
    readonly shopLanguageName: string;
    readonly sortIndex: number;
    readonly languageCodes?: ReadonlyArray<string>;
};

export enum AuthenticationActionType {
    SET_SPOC = 'SET_SPOC'
}

export type SetSpocAction = {
    type: AuthenticationActionType.SET_SPOC;
    payload: SpocState;
};

export type AuthenticationAction = SetSpocAction;

export const initialAuthenticationState = { spoc: {} as SpocState };

export function authenticationReducer(
    authentication: AuthenticationState = initialAuthenticationState,
    action: AuthenticationAction
): Partial<AuthenticationState> {
    switch (action.type) {
        case AuthenticationActionType.SET_SPOC:
            return { ...authentication, spoc: action.payload };

        default:
            return authentication;
    }
}
